import { forTablet, forMidDesktop } from '@westwing/ui-kit/breakPoints';
import styled, { css } from 'styled-components';

export const SkeletonContainer = styled.div`
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.white};
    overflow: hidden;

    display: grid;
    align-items: center;
    grid-gap: 1rem;

    --padding-mobile-x: 24px;
    grid-template-columns: repeat(2, min(48%, 252px));
    grid-template-rows: repeat(4, 38px) 58px;
    padding: 30vh calc(var(--padding-mobile-x) + 1rem) 0px var(--padding-mobile-x);

    /* This is survey sparrow's breakpoint, not ours */
    @media screen and (min-width: 480px) {
        --padding-mobile-x: 15%;
    }

    ${forTablet`
        grid-template-rows: repeat(8, 38px) 58px;
        padding: 30vh 22% 0;
        grid-col-gap: 0;
    `}

    ${forMidDesktop`
        &[data-language="fr"],
        &[data-language="nl"] {
            grid-template-columns: 1fr;
        }
        padding: calc(26vh - 5px) 28% 0;
    `}
`;

export const SkeletonItem = styled.div.attrs({
    'data-testid': 'skeleton-item',
})`
    @keyframes skeleton {
        0%,
        100% {
            opacity: 0.3;
        }

        50% {
            opacity: 0.1;
        }
    }

    background: ${({ theme }) => theme.colors.skeleton02};
    opacity: 1;
    animation: skeleton 1.5s infinite;
    border-radius: 8px;
`;

export const SkeletonMcqOption = styled(SkeletonItem)`
    height: 38px;

    ${SkeletonContainer}[data-language="fr"] &,
    ${SkeletonContainer}[data-language="nl"] & {
        ${forTablet`
            max-width: 250px;
        `}
    }
`;

export const SkeletonButton = styled(SkeletonItem)`
    height: 58px;
    padding: 20px 24px;
    margin-top: 3.7rem;
    max-width: 174px;

    ${forTablet`
        max-width: 155px;
        margin-top: 5rem;
    `}
`;

export const Wrapper = styled.section<{
    $isLoading: boolean;
    $height: ReturnType<typeof css>;
}>`
    position: relative;
    ${({ $height }) => $height}

    iframe {
        width: 100%;
        height: 100%;
        ${({ $isLoading }) =>
            $isLoading
                ? css`
                      inset: 0;
                      position: absolute;
                  `
                : ''}
    }

    > *:not(${SkeletonContainer}) {
        visibility: ${({ $isLoading }) => ($isLoading ? 'hidden' : 'visible')};
    }

    ${SkeletonContainer} {
        display: ${({ $isLoading }) => ($isLoading ? 'grid' : 'none')};
        z-index: 100;
    }
`;
